export type TabIconVariant = 'pending' | 'success' | 'error' | 'default';
